module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"button":{"add_account":"アカウントを追加"},"menu":{"account":"アカウント","distributor_account":"代理店アカウント"}},"en":{"button":{"add_account":"Add account"},"menu":{"account":"Account","distributor_account":"Distributor account"}}}')
  delete Component.options._Ctor
}
